var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 129,
    viewBox: "0 0 124 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 56.5219V115.272C123.676 122.572 117.751 128.497 110.451 128.497H13.5258C6.22578 128.497 0.300781 122.572 0.300781 115.272V56.5219L52.6758 4.34688C57.8258 -0.803125 66.1758 -0.803125 71.3508 4.34688L123.676 56.5219Z",
    fill: "#FF9D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8759 15.2227H100.251C107.551 15.2227 113.476 21.1477 113.476 28.4477V104.823C113.476 112.123 107.551 118.048 100.251 118.048H23.8759C16.5759 118.048 10.6509 112.123 10.6509 104.823V28.4227C10.6509 21.1227 16.5759 15.2227 23.8759 15.2227Z",
    fill: "#F4EEE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 56.5234V115.273C123.676 122.573 117.751 128.498 110.451 128.498H13.5258C6.22578 128.498 0.300781 122.573 0.300781 115.273V56.6984L61.9008 118.298L123.676 56.5234Z",
    fill: "#FFBE1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.851 124.597C117.776 126.697 114.976 128.097 111.876 128.447L13.0759 128.497C9.60088 128.372 6.45088 126.897 4.15088 124.597L52.6509 76.0969C57.8009 70.9469 66.1759 70.9469 71.3509 76.0969L119.851 124.597Z",
    fill: "#FFE000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0011 65.7492C74.1651 65.7492 84.0261 55.8883 84.0261 43.7242C84.0261 31.5601 74.1651 21.6992 62.0011 21.6992C49.837 21.6992 39.9761 31.5601 39.9761 43.7242C39.9761 55.8883 49.837 65.7492 62.0011 65.7492Z",
    fill: "#06329D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6261 34.2977C73.7761 33.4477 72.3761 33.4477 71.5011 34.2977L57.3511 48.4477L52.4261 43.5227C51.6011 42.6977 50.2261 42.6977 49.4011 43.5227L49.3511 43.5727C48.4761 44.4477 48.4761 45.8477 49.3511 46.6977L55.7761 53.1227C56.6261 53.9727 58.0261 53.9727 58.9011 53.1227L74.6261 37.3977C75.5011 36.5477 75.5011 35.1477 74.6261 34.2977Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferSuccess);
export default __webpack_public_path__ + "static/media/offer-success.aa1e8eeb15308e1b5e6569ec477f03b3.svg";
export { ForwardRef as ReactComponent };